import { fetchAccumulatedOfferById } from 'actions/OfferActions'
import { useAppDispatch, useAppSelector } from 'hooks/reduxHooks'
import { useEffect } from 'react'

function useOffer<T extends App.OfferBase = App.AnyOffer>(offerId?: string): [T, boolean] {
  const dispatch = useAppDispatch()

  useEffect(() => {
    if (offerId) {
      dispatch(fetchAccumulatedOfferById(offerId))
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [offerId])

  const offer: any = useAppSelector<App.AnyOffer>((state) =>
    state.offer.offers[offerId] ??
    state.offer.offerSummaries[offerId] ??
    state.offer.tourV2Offers[offerId] ??
    state.offer.bedbankOffers[offerId] ??
    state.offer.bedbankOfferSummaries[offerId],
  )

  const fetching = useAppSelector(state => state.offer.offersLoading[offerId])

  return [
    offer,
    fetching,
  ]
}

export default useOffer
